import request from '@/server/request';
import {API_SYS} from '@/utils/base';

/**
 * 文件上传
 */
export async function apiUploadFile (params) {
  return request(API_SYS + '/common/uploadFile', {
    method: 'POST',
    data: params
  });
}

/**
 * 根据字典组编码获取字典项
 */
export async function apiGetDictListByCode (params) {
  return request(API_SYS + '/sys/dictionary/getDictListByCode', {
    method: 'GET',
    params: params
  });
}

/**
 * 获取指定层级的区域树
 */
export async function apiGetTreeByDeep (params) {
  return request(API_SYS + '/sys/area/getTreeByDeep', {
    method: 'GET',
    params: params
  });
}

/**
 * 根据父id获取区域列表
 */
export async function apiGetAreasByPid (params) {
  return request(API_SYS + '/sys/area/getAreasByPid', {
    method: 'GET',
    params: params
  });
}

/**
 * 买家中心-查询用户明细
 */
export async function apiGetUserInfo (params) {
  return request(API_SYS + '/sys/user/info', {
    method: 'GET',
    // data: params
  });
}

/**
 * 买家中心-获取当前登录用户关联的企业信息
 */
export async function apiGetUserCompany (params) {
  return request(API_SYS + '/sys/user/jgw/getUserCompany', {
    method: 'GET',
    // data: params
  });
}

/**
 * 买家中心-修改用户基本信息
 */
export async function apiUpdateUserInfo (params) {
  return request(API_SYS + '/sys/user/jgw/updateUserInfo', {
    method: 'POST',
    data: params
  });
}

//修改密码
export async function updatePassword (params) {
  return request(API_SYS + '/sys/user/updatePassword', {
    method: 'POST',
    params: params,
  });
}

/**
 * 买家中心-修改用户基本信息
 */
export async function apiSendSmsCode (params) {
  return request(API_SYS + '/sys/sms/sendSmsCode', {
    method: 'GET',
    params: params,
  });
}

/**
 * 买家中心-修改用户基本信息
 */
export async function apiForgetPwd (params) {
  return request(API_SYS + '/sys/user/jgw/forgetPwd', {
    method: 'POST',
    data: params,
  });
}

//发送短信
export async function sendSmsCode (params) {

  return request(API_SYS + '/sys/sms/sendSmsCode', {
    method: 'GET',
    params: params
  });
}

//验证短信验证码
export async function sendVerifyMsgCode (params) {

  return request(API_SYS + '/sms/verifyMsgCode', {
    method: 'GET',
    params: params
  });
}

//忘记密码
export async function forgetPwd (params) {
  console.log(params);
  return request(API_SYS + '/sys/user/jgw/forgetPwd', {
    method: 'POST',
    data: params
  });
}

/**
 * 登录
 * @param params
 * @returns {Promise<*>}
 */
export async function authLogin (params) {
  return request(API_SYS + '/sys/auth/jgw/login', {
    method: 'POST',
    data: params
  });
}

/**
 * 登出
 * @returns {Promise<*>}
 */

export async function authLogOut () {
  return request(API_SYS + '/sys/auth/logout', {
    method: 'POST',
  });
}

// 电商网站注册接口
export async function createuser (params) {
  console.log(params);
  return request(API_SYS + '/sys/auth/jgw/register', {
    method: 'POST',
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/sys.js